export type AuthMode = 'oidc' | 'dev' | 'msw';

interface ModeInputs {
  DEV: boolean;
  msw: string | undefined;
  devAuth: string | undefined;
}

/** Pure resolver so the precedence rules are unit-testable. */
export function resolveAuthMode({ DEV, msw, devAuth }: ModeInputs): AuthMode {
  if (msw === 'true') return 'msw';
  if (DEV && devAuth === 'true') return 'dev';
  return 'oidc';
}

export const AUTH_MODE: AuthMode = resolveAuthMode({
  DEV: import.meta.env.DEV,
  msw: import.meta.env.VITE_MSW,
  devAuth: import.meta.env.VITE_DEV_AUTH,
});
